import Clocks from './Clocks';

export default Clocks;
